$(document).ready(function(){
    
    $('.backtop').on('click', function () {
        $("html, body").animate({
            scrollTop: 0
        }, 1000);
        return false;
    });

    $('.mob-panel .btn').click(function(){
        $('.collapse.in').collapse('hide');
    });

    switchPos();
  
    $(".template-homepage-mobile .tiles li").matchHeight({
      byRow: true
    });
 
    $('.popup-gallery').magnificPopup({
          delegate: 'a',
          type: 'image',
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
          },
          image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
          }
    });
    $('.alert-danger').each(function(){
      var f = $(this);
      $(this).find(".btn-default").click(function(e){
        f.fadeOut();
        e.preventDefault();
      })
    });

    $('.alert-success').each(function () {
        var f = $(this);
        $(this).find(".btn-default").click(function(e) {
            f.fadeOut();
            e.preventDefault();
        });
    });


    $('.modal').on('show.bs.modal', function() {
          $(this).show();
          setModalMaxHeight(this);
    }); 

    if ($('.quick-search-slider').length != 0) {
        
                $('.quick-search-slider').slick({
                  dots: false,
                  arrows: true,
                  infinite: false,
                  speed: 300,
                  slidesToShow: 11,
                  slidesToScroll: 11,
                  responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 9,
                        slidesToScroll: 9,
                        infinite: true,
                        dots: true
                      }
                    },
                    {
                      breakpoint: 992,
                      settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6
                      }
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                      }
                    } 
                  ]
                });

        if (windowW > 1199) {
            if ($('.quick-search-slider .tiles__item').length <= 10) {
                $('.quick-search-slider').slick('unslick');
            }
        } 

    }
    

});

$(window).resize(function(){
    switchPos();
    if ($('.modal.in').length != 0) {
        setModalMaxHeight($('.modal.in'));
    }
});

function setModalMaxHeight(element) {
          var $element     = $(element);  
          var $content     = $element.find('.modal-content');
          var borderWidth   = $content.outerHeight() - $content.innerHeight();
          var dialogMargin  = $(window).width() < 768 ? 20 : 60;
          var contentHeight = $(window).height() - (dialogMargin + borderWidth);
          var headerHeight  = $element.find('.modal-header').outerHeight() || 0;
          var footerHeight  = $element.find('.modal-footer').outerHeight() || 0;
          var maxHeight     = contentHeight - (headerHeight + footerHeight);

          $content.css({
              'overflow': 'hidden'
          });
          
          $element
            .find('.modal-body').css({
              'max-height': maxHeight,
              'overflow-y': 'auto'
          });
}

function switchPos(){
        var currWidth = $(window).width();
        if(currWidth <= 767){
            $('.location--lead').insertAfter('.details');
        }
        if(currWidth >= 768){
            $('.details').insertAfter('.location--lead');
        } 
}